<template>
  <ul>
    <li class="folders-name text-secondary">
      <i class="fas fa-folder text-warning treeview-item-icon pr-1"></i>{{ names.name }}
      <FoldersName v-if="names.child && names.child.name" :names="names.child" />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'FoldersName',
  props: {
    names: {
      type: Object,
      required: true
    }
  },
  methods: {
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  padding-left: 20px;
}

ul li.folders-name {
  white-space: normal;
}

ul li.folders-name:before {
  content: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/foldersname/foldersname.vue